var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32633 0.833496C3.0305 0.833496 1.15967 2.70433 1.15967 5.00016C1.15967 7.296 3.0305 9.16683 5.32633 9.16683C7.62217 9.16683 9.493 7.296 9.493 5.00016C9.493 2.70433 7.62217 0.833496 5.32633 0.833496ZM7.13883 6.48766C7.0805 6.58766 6.97633 6.64183 6.868 6.64183C6.81383 6.64183 6.75967 6.62933 6.70967 6.596L5.418 5.82516C5.09717 5.6335 4.85967 5.21266 4.85967 4.84183V3.1335C4.85967 2.96266 5.00133 2.821 5.17217 2.821C5.343 2.821 5.48467 2.96266 5.48467 3.1335V4.84183C5.48467 4.99183 5.60967 5.21266 5.73883 5.28766L7.0305 6.0585C7.1805 6.146 7.2305 6.33766 7.13883 6.48766Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.cdac8f260a44e3323c7c4e34e4fabf91.svg";
export { ForwardRef as ReactComponent };